"use client";
import useTranslate from "@app/_hooks/useTranslate";

import Link from "@components/Link";
import { ArrowLeftIcon } from "@ngg/icons";
import { useRouter } from "next/navigation";

import { cn } from "@/lib/utils";

import { useBreadcrumbsPath } from "./Breadcrumb.hooks";

type BreadcrumbsPreviousLinkProps = {
  className?: string;
  href: string;
  locale?: string;
  isProductPage?: boolean;
};

export default function BreadcrumbsPreviousLink({
  className,
  href,
  locale,
  isProductPage,
}: BreadcrumbsPreviousLinkProps) {
  const t = useTranslate();

  const router = useRouter();
  const { hasPreviousPath } = useBreadcrumbsPath();

  const hasBackTranslation = t("back", { strict: true });

  if (isProductPage && hasPreviousPath) {
    return (
      <button
        className="inline-flex content-center items-center gap-0.5 border border-grey-150 bg-white px-1.5 py-1 text-black transition-colors duration-150 hover:border-black hover:text-black"
        onClick={() => {
          router.back();
        }}
      >
        <ArrowLeftIcon
          className={cn(
            "max-lg:text-black",
            hasBackTranslation ? "h-4 w-4" : "h-5 w-5",
          )}
        />
        {t("back")}
      </button>
    );
  }

  return (
    <Link
      href={href}
      locale={locale}
      prefetch={false}
      className={cn(
        "inline-flex content-center items-center gap-0.5 transition-colors duration-150 hover:text-black",
        hasBackTranslation
          ? "border border-grey-150 bg-white px-1.5 py-1 text-black hover:border-black"
          : "lg:hidden",
        className,
      )}
    >
      <ArrowLeftIcon
        className={cn(
          "max-lg:text-black",
          hasBackTranslation ? "h-4 w-4" : "h-5 w-5",
        )}
      />
      {t("back")}
    </Link>
  );
}
